import React from 'react';
class OverView extends React.PureComponent {
  render() {
    const { symbol } = this.props;
    return (
      <iframe
        className="mt-2"
        title="chart"
        src={'/chartTVS/?theme=dark&symbol=' + symbol}
        scrolling="no"
      ></iframe>
    );
  }
}

export default OverView;
